module.exports = __webpack_public_path__ + "static/img/33eca213580db4e37367d8ad3ec5b26d.6a5d227a.gif";